import { Button, Text } from 'components';
import { TEXT_STRING } from '../../../constants';
import { useCallback, useState } from 'react';
import PlanContainer from './PlanContainer';

const COMMON_STR = TEXT_STRING.COMMON;
const MENU_STR = TEXT_STRING.PRICE_LIST;

type Props = {
  onNext: () => Promise<void>;
};

export default function PriceList({ onNext }: Props) {
  const [selectScene, setSelectScene] = useState<Set<number>>(new Set([0]));
  const [isExpanded, setIsExpanded] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);

  // Callbacks
  const handleToggle = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const handleSelectScene = useCallback((index: number) => {
    setSelectScene((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  }, []);

  const handleNext = useCallback(async () => {
    setLoading(true);
    await onNext();
    setLoading(false);
  }, [onNext]);

  return (
    <div className="h-full flex flex-col justify-between overflow-y-auto px-5 pt-5">
      <div className="w-full pb-5">
        <Text
          className="leading-snug"
          fontWeight="font-extrabold"
          fontSize={20}
        >
          {MENU_STR.TITLE}
        </Text>
        <Text className="text-neutral-200" fontWeight="font-bold" fontSize={12}>
          {MENU_STR.MULTIPLE_SELECT}
        </Text>

        <div className="flex flex-wrap gap-4 mt-4">
          {MENU_STR.SCENE_LIST.map((scene, index) => {
            const selected = selectScene.has(index);
            return (
              <Button
                key={`scene-${index}`}
                onClick={() => handleSelectScene(index)}
                className={
                  'tracking-wide border px-6 py-2.5 hover:opacity-75 ' +
                  (selected
                    ? 'bg-primary hover:bg-primary text-white border-primary'
                    : 'bg-white hover:bg-white !text-neutral-400 border-neutral-400')
                }
                bold
                rounded="rounded-lg"
                aria-pressed={selected}
              >
                {scene}
              </Button>
            );
          })}
        </div>
      </div>

      <div>
        <PlanContainer isExpanded={isExpanded} handleToggle={handleToggle} />
        <div className="w-full sticky left-0 bottom-0 bg-white py-5 border-t border-solid border-neutral-50">
          <Button
            onClick={handleNext}
            className="w-full p-5"
            bold
            loading={loading}
            disabled={loading}
          >
            {COMMON_STR.NEXT}
          </Button>
        </div>
      </div>
    </div>
  );
}
